import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Senza sessione si va subito al login: la schermata di avvio non serve più
window.addEventListener("load", () => {
  const hasSession = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!hasSession && window.hideAppSplash) window.hideAppSplash();
});
